import React, { useEffect, useState } from "react";
import { getFoodItems, IMAGE_URL } from "../api/api";
import { Link } from "react-router-dom";
import "../styles/RelatedItems.css";

// Utility to shuffle array
const shuffle = arr => arr
  .map(v => ({ v, sort: Math.random() }))
  .sort((a, b) => a.sort - b.sort)
  .map(({ v }) => v);

const RelatedItems = ({ excludeId, count = 4 }) => {
  const [related, setRelated] = useState([]);

  useEffect(() => {
    getFoodItems()
      .then(res => {
        const all = Array.isArray(res.data) ? res.data : [];
        const filtered = all.filter(item => item.id.toString() !== excludeId);
        setRelated(shuffle(filtered).slice(0, count));
      })
      .catch(err => console.error("Failed to load related items", err));
  }, [excludeId, count]);

  if (!related.length) return null;

  return (
    <div className="related-section">
      <h3>Related Items</h3>
      <div className="related-grid">
        {related.map(item => (
          <Link
            key={item.id}
            to={`/menu/${item.id}`}
            className="related-card"
          >
            <img
              src={`${IMAGE_URL}${item.image}`}
              alt={item.name}
              className="related-image"
            />
            <div className="related-content">
              <strong className="related-title">{item.name}</strong>
              <span className="related-price">₹{Number(item.price).toFixed(2)}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedItems;
